import { render, staticRenderFns } from "./gcp.vue?vue&type=template&id=0b05af97&"
import script from "./gcp.vue?vue&type=script&lang=js&"
export * from "./gcp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports